import { useTranslation } from 'react-i18next'

import { useConfirm } from '@/components/ui/confirm-dialog'

/** Confirmation before e-mailing landlords a create-password link. */
export function useConfirmLandlordInvite() {
  const { t } = useTranslation('users')
  const { confirm, dialog } = useConfirm()

  const confirmInvite = (count: number) =>
    confirm({
      title: t('landlordInvite.confirm.title'),
      description: t('landlordInvite.confirm.description', { count }),
      confirmText: t('landlordInvite.confirm.submit'),
      cancelText: t('landlordInvite.confirm.cancel')
    })

  return { confirmInvite, dialog }
}
